const getters = {
  visibleColumns: state => state.columns.filter(col => col.showColumn),

  hasFiltersApplied: state => Object.keys(state.filters).length !== 0,
};

export default getters;
